import type { Theme, SxProps } from "@mui/material/styles";

/**
 * Styles for Category Tag component
 */
export const categoryTagStyles = (
  theme: Theme,
): Record<string, SxProps<Theme>> => ({
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "100%",
    marginLeft: "12px",
  },
  colorCircle: {
    width: "26px",
    height: "26px",
    borderRadius: "4px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    fontWeight: "bold",
    marginRight: "8px",
  },
});
